<div [formGroup]="parentForm">
  <wsd-extended-input label="{{ showLabel ? (label | translate) : ''  }}"
                     [control]="parentForm.get(controlName)">
    <p-dropdown [options]="items"
                placeholder="{{ showPlaceholder ? (placeholder | translate) : ''}}"
                [formControlName]="controlName"
                (onChange)="change()">
    </p-dropdown>
  </wsd-extended-input>
</div>
